import { Link } from 'react-router'
import { ShieldOff } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export default function SinAccesoMunicipio({ slug }: { slug: string }) {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-muted/40 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <ShieldOff className="size-6 text-muted-foreground" aria-hidden="true" />
          <CardTitle>No tienes acceso a este municipio</CardTitle>
          <CardDescription>
            {slug === ''
              ? 'La dirección no indica ningún municipio.'
              : `Tu cuenta no está habilitada en «${slug}».`}{' '}
            Si crees que es un error, pídele al administrador que te agregue.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button render={<Link to="/municipios" />}>Ver mis municipios</Button>
        </CardContent>
      </Card>
    </main>
  )
}
